import { createSlice } from "@reduxjs/toolkit";

import { clearStore } from "actions/initialization";
import { getStatsThunk } from "thunks/stats";

const initialState = {
  loading: true,
  error: null,
};

const statsSlice = createSlice({
  name: "stats",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // #region pending
      .addCase(getStatsThunk.pending, (state) => {
        state.loading = true;
      })
      // #endregion
      // #region fulfilled
      .addCase(getStatsThunk.fulfilled, (state, action) => {
        const stats = action.payload;
        return {
          ...state,
          ...stats,
          loading: false,
        };
      })
      // #endregion
      // #region rejected
      .addCase(getStatsThunk.rejected, (state, action) => {
        const { error } = action;
        state.loading = false;
        state.error = error;
      })
      // #endregion
      .addCase(clearStore, () => initialState);
  },
});

export const actions = statsSlice.actions;

export default statsSlice.reducer;
